/**
 * Quality Co-Pilot history drawer — now the SHARED ConversationHistoryDrawer
 * (components/agentConsole), kept as a thin wrapper so QualityCopilotPage's
 * import path stays unchanged. The shared drawer defaults its title to "Your
 * conversations", matching the Co-Pilot's prior copy.
 */
import {
  ConversationHistoryDrawer,
  type ConversationHistoryDrawerProps,
} from '../components/agentConsole/ConversationHistoryDrawer';

export function QcpConversationDrawer(props: ConversationHistoryDrawerProps) {
  return <ConversationHistoryDrawer {...props} />;
}
